import axios from './axiosTool.js'
import ElementUI from "element-ui";
//文件=>blob
function filesToBlob(file) {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = function(e) {
            let blob = dataURLtoBlob(e.target.result)
            resolve({
                url: blob
            })
        };
        reader.readAsDataURL(file);
    })

}

function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
        type: mime
    });
}
//base64转文件流
function dataURItoFile(dataurl, type, filename) {
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
        type: type,
        lastModified: Date.now()
    });
}
//generateUUID
function generateUUID() {
    let d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    let uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}
//上传校验
function upload(file) {
    console.log(file,'file')
    let pos = file.name.lastIndexOf(".");
    let suffix = '';
    if (pos != -1) {
        suffix = file.name.substring(pos);
        console.log(suffix, 'suffix')
        suffix = suffix.toLocaleLowerCase()
    }

    const isfile = suffix === '.jpg' || suffix === '.png' || suffix === '.mp4' || suffix === '.mp3' || suffix === '.doc' || suffix === '.docx' || suffix  === '.ppt' || suffix === '.pptx' || suffix === '.xls' || suffix === '.xlsx' || suffix === '.pdf';
    const isLt25M = file.size / 1024 / 1024 < 25;
    const isLt100M = file.size / 1024 / 1024 < 100;
    console.log(file, isfile, isLt25M, isLt100M)
    //格式校验
    return new Promise((resolve, reject) => {
        if (!isfile) {
            ElementUI.Message.error('只能上传JPG/PNG/MP4/MP3/word/Excel/ppt/pdf 格式!');
            reject(false)
        }
        //大小校验
        if (file.type === 'video/mp4') {
            if (!isLt25M) {
                ElementUI.Message.error('选择视频大小不能超过 25MB!');
                reject(false)
            }
        } else if (file.type === 'image/jpeg' || file.type === 'image/png') {
            if (!isLt25M) {
                ElementUI.Message.error('选择图片大小不能超过 25MB!');
                reject(false)
            }
        } else {
            if (!isLt100M) {
                ElementUI.Message.error('选择文件大小不能超过 100MB!');
                reject(false)
            }
        }
        resolve({
            file: file
        })
    })
}

//获取oss配置
function getossbase(file,bool) {
    console.log('oss',file)
    let pos = file.name.lastIndexOf(".");
    let suffix = '';
    if (pos != -1) {
        suffix = file.name.substring(pos);
        console.log(suffix, 'suffix')
    }
    let fileidlist = {}
    let uuid = generateUUID();
    let filename = "",
        urldata = "";
    if(bool){
        filename= file.name
        urldata = JSON.parse(localStorage.getItem('user')).companyId+"&businessType=" +localStorage.getItem('initBusType') + "&uuid=" +uuid
    }else{
        filename= uuid + suffix
        urldata = JSON.parse(localStorage.getItem('user')).companyId+"&businessType=" +localStorage.getItem('initBusType')
    }


    return new Promise((resolve, reject) => {
        axios.post('/oss/findOssConfigInfo?companyId='+urldata, {})
            .then(res => {
                if (res.data.code == 200) {
                    let {
                        accessId,
                        dir,
                        fileUrl,
                        host,
                        policy,
                        sign
                    } = res.data.data
                    fileidlist[uuid] = {
                        filename: filename,
                        host: fileUrl,
                        type: suffix
                    }
                    let formData = new FormData();
                    formData = {
                        'key': dir + filename,
                        'OSSAccessKeyId': accessId,
                        'policy': policy,
                        'Signature': sign,
                        'success_action_status': 200,
                    }
                    let upload_params = {
                        host: host,
                        multipart_params: formData
                    }

                    resolve({
                        file: file,
                        upload_params: upload_params,
                        isChrome: true,
                        uuid: uuid,
                        fileidlist: fileidlist
                    });
                    console.log(uuid, 'uuid', file)
                } else {
                    ElementUI.Message.error('获取oss上传参数失败')
                    reject(res)
                }
            }).catch(err => {
                reject(err)
            })
    })

}

//上传并返回文件和uuid
function uploadform(data) {
    let {
        file,
        upload_params,
        isChrome,
        uuid
    } = data
    console.log(file, upload_params, isChrome, uuid, 'uploadImgFromPaste')
    var formData = new FormData();
    for (let key in upload_params.multipart_params) {
        formData.append(key, upload_params.multipart_params[key]);
    }
    formData.append('file', file);
    console.log(formData, 'formData')
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', upload_params.host);
        xhr.onload = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {

                    console.log('上传成功！')
                    //this.uploadSuccess(file, uuid)
                    let obj = {
                        file,
                        uuid
                    }
                    resolve(obj)
                } else {
                    reject(xhr.statusText);
                }
            };
        };
        xhr.onerror = function(e) {
            reject(xhr.statusText);
        }
        xhr.send(formData);
    })
}
//分割
function getUrlQuery (name, url) {
  var query = url;
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == name) {
      return pair[1];
    }
  }
  return (false);
}


export default {
    getUrlQuery,
    dataURItoFile,
    generateUUID,
    upload,
    filesToBlob,
    getossbase,
    uploadform
}



// WEBPACK FOOTER //
// ./src/utils/upload.js